<head>

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<div class="user-management-container">
    <div class="row">
        <div class="col-sm-10 ">
            <div class="title">
                User Management
            </div>
            <div class="sub-title">
                20 users
            </div>
        </div>
        <div class="col-sm-2 add-user">
            <button type="button" class="btn btn-primary"  [routerLink]="'new'">Add
                User</button>
        </div>
    </div>


    <div class="search-container">
        <div class="row">
            <div class="col-sm-8">

                <div class="row">
                    <div class="col">
                        <input type="email" class="form-control" placeholder="Name">
                    </div>
                    <div class="col">
                        <input type="email" class="form-control" placeholder="Email">
                    </div>

                </div>
            </div>
            <div class="col-sm-2">
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary">Search</button>
                </div>


            </div>
            <div class="col-sm-2">

                <div class="d-flex justify-content-start">
                    <button type="button" class="btn btn-grey">Clear</button>
                </div>
            </div>


        </div>
    </div>


    <table class="table table-hover table-bordered">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Actions</th>
            </tr>
        </thead>
        <tbody *ngFor="let user of usersList; let i=index ">
            <tr>
                <th scope="row">{{i+1}}</th>
                <td>Mark</td>
                <td>Otto</td>
                <td class="action-column">
                    <div class="action-buttons">

                        <button class="btn btn-danger btn-sm">Deactivate</button>
                        <button class="btn btn-primary btn-sm">Edit</button>
                        <button class="btn btn-grey btn-sm">View</button>
                    </div>
                </td>
            </tr>


        </tbody>

    </table>
    <div class="footer">
        <pagination [totalCount]="80" [pageSize]="15" [currentPage]="1">
        </pagination>
    </div>

</div>
